import React from "react";
import MarketingNav from "@/components/MarketingNav";
import Seo from "@/components/Seo";
import SiteFooter from "@/components/SiteFooter";
import { BIZ } from "@/data/site";

export default function PrivacyPage() {
  const updated = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  return (
    <div className="bg-paper min-h-screen">
      <Seo title="Privacy Policy" description="Privacy policy for Wynridge Exterior Cleaning." path="/privacy-policy/" noIndex={false} />
      <MarketingNav />
      <article className="pt-36 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-stone">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-700 mb-4">Legal</div>
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-stone-900" style={{ fontFamily: "Outfit" }}>Privacy Policy</h1>
          <p className="text-sm text-stone-500">Last updated: {updated}</p>

          <h2>Who we are</h2>
          <p>This site is operated by {BIZ.name}, based in {BIZ.city}, {BIZ.stateShort} {BIZ.zip}. You can reach us at <a href={`mailto:${BIZ.email}`}>{BIZ.email}</a> or {BIZ.phone}.</p>

          <h2>What we collect</h2>
          <ul>
            <li><b>Contact info you submit</b> — name, phone, email, service address, and notes you provide via our quote or estimate forms.</li>
            <li><b>Automatic technical data</b> — standard web-server logs (IP address, browser type, referring pages) and any analytics cookies you consent to.</li>
          </ul>

          <h2>How we use it</h2>
          <ul>
            <li>To contact you about your quote, schedule service, and follow up.</li>
            <li>To send occasional service reminders — you can opt out at any time by replying STOP.</li>
            <li>To keep our site working, prevent abuse, and improve performance.</li>
          </ul>

          <h2>Who we share it with</h2>
          <p>We don&apos;t sell or rent your data. We share it only with service providers who help us run the site (hosting, SMS delivery, email) and only for the purposes above. If required by law we&apos;ll cooperate with legal requests.</p>

          <h2>Text messages</h2>
          <p>By providing your phone number, you agree to receive service-related messages from Wynridge Exterior Cleaning. Message and data rates may apply. Reply STOP to opt out, or HELP for help.</p>

          <h2>Cookies</h2>
          <p>We use only essential cookies for site functionality. If we add analytics tools we&apos;ll ask for consent first.</p>

          <h2>Your choices</h2>
          <p>Email us at <a href={`mailto:${BIZ.email}`}>{BIZ.email}</a> to request access, correction, or deletion of any personal info we hold about you.</p>

          <h2>Changes</h2>
          <p>We may update this policy from time to time. The &quot;Last updated&quot; date at the top will reflect the change.</p>
        </div>
      </article>
      <SiteFooter />
    </div>
  );
}
